import { createReducer, on } from '@ngrx/store';
import { homeInitialState } from '@store/states/home.state';
import { homeActions } from '@store/actions/home.actions';

export const homeReducer = createReducer(
  homeInitialState,
  on(homeActions.setMyServices, (state, { services }) => ({
    ...state,
    myServices: services,
  })),
  on(homeActions.setMyInvoices, (state, { invoices }) => ({
    ...state,
    myInvoices: invoices,
  })),
);
